import cn from 'classnames';
import * as React from 'react';

import ToggleField from 'components/Form/ToggleField';
import { ClosedCaptioning } from 'components/icons';

import TranscriptionFormContext, {
  TranscriptionFormValue,
} from './TranscriptionFormContext';
import { block } from './utils';

type Props = Pick<React.ComponentProps<typeof ToggleField>, 'label'> & {
  icon?: React.ReactNode;
  labelClassName?: string;
  onChangeListener?: (value: TranscriptionFormValue) => void;
};

const { useContext, useCallback } = React;

const TranscriptionToggle: React.FC<Props> = props => {
  const {
    icon = <ClosedCaptioning width={29} />,
    labelClassName,
    label = 'Add captions to video',
    onChangeListener,
  } = props;
  const { value, onChange, disabled } = useContext(TranscriptionFormContext);

  const handleTranscribeChange = useCallback(
    (transcribe: boolean) => {
      onChange({ ...value, transcribe });
      onChangeListener?.({ ...value, transcribe });
    },
    [onChange, onChangeListener, value],
  );

  return (
    <ToggleField
      checked={value.transcribe}
      className={block('toggle-field')}
      disabled={disabled}
      horizontal={{
        control: { xs: 4 },
        label: { xs: 8 },
      }}
      label={
        <>
          {icon}
          <span className={block('label-text')}>{label}</span>
        </>
      }
      labelClassName={cn(block('label'), labelClassName)}
      onChange={handleTranscribeChange}
    />
  );
};

TranscriptionToggle.displayName = 'Transcription.Toggle';

export default TranscriptionToggle;
